import { render, staticRenderFns } from "./cargoRichTextarea.vue?vue&type=template&id=080553b1&"
import script from "./cargoRichTextarea.vue?vue&type=script&lang=js&"
export * from "./cargoRichTextarea.vue?vue&type=script&lang=js&"
import style0 from "./cargoRichTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080553b1')) {
      api.createRecord('080553b1', component.options)
    } else {
      api.reload('080553b1', component.options)
    }
    module.hot.accept("./cargoRichTextarea.vue?vue&type=template&id=080553b1&", function () {
      api.rerender('080553b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoRichTextarea.vue"
export default component.exports